import { render, staticRenderFns } from "./DownloadStatistics.vue?vue&type=template&id=23689528&scoped=true"
import script from "./DownloadStatistics.vue?vue&type=script&lang=js"
export * from "./DownloadStatistics.vue?vue&type=script&lang=js"
import style0 from "./DownloadStatistics.vue?vue&type=style&index=0&id=23689528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23689528",
  null
  
)

export default component.exports